import { style } from '@vanilla-extract/css';

import { stack } from './Columns.css';

export const column = style({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  '@media': {
    'only screen and (max-width:667px)': {
      selectors: {
        [`${stack} > &`]: {
          width: '100% !important',
        },
      },
    },
  },
});

export const growColumn = style({
  flexGrow: 1,
  flexShrink: 0,
});
